import { lazy } from 'react';
import { AdvancedCobranding } from '../../utilities/cobranding/cobranding';
import { AdvancedCobrandedPage } from '../orchestrator';

export const pages: Array<AdvancedCobrandedPage> = [
  {
    experience: AdvancedCobranding.DEMO,
    Component: lazy(() => import('../../advanced-cobranding/pollinator/demo/LoginPage')),
    owner: 'iignatov2@atlassian.com',
    slackChannel: 'id-kirby',
    monitoringUrls: [
      'prod: https://pollinator.prod.atl-paas.net/checks/ae69f832-ceac-472c-9cb3-916cdc50e48f',
      'stg: https://pollinator.prod.atl-paas.net/checks/efa267f0-f1e2-456f-8ef8-c34a3c32b350',
      'ddev: https://pollinator.prod.atl-paas.net/checks/6e9db949-2d59-40dc-861b-5381070f2be7',
    ],
  },
  {
    experience: AdvancedCobranding.PRT_DEMO,
    Component: lazy(() => import('../../advanced-cobranding/prt/demo/LoginPage')),
    owner: 'jbell2@atlassian.com',
    slackChannel: 'id-kirby',
    monitoringUrls: ['KIRBY-9547: Add monitoring URLs for PRT demo'],
  },
  {
    experience: AdvancedCobranding.CONFLUENCE_ATLAS_75650,
    Component: lazy(
      () => import('../../advanced-cobranding/admin/atlas-75650/LoginPage/defaultPage')
    ),
    owner: 'rrai2@atlassian.com',
    slackChannel: 'help-ipg',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
      'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10',
    ],
  },
  {
    experience: AdvancedCobranding.JIRA_ATLAS_75650,
    Component: lazy(
      () => import('../../advanced-cobranding/admin/atlas-75650/LoginPage/defaultPage')
    ),
    owner: 'rrai2@atlassian.com',
    slackChannel: 'help-ipg',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
      'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10',
    ],
  },
  {
    experience: AdvancedCobranding.ACCOUNT_LINKING,
    Component: lazy(() => import('../../advanced-cobranding/community/account-linking/login-page')),
    owner: 'vmanjunath@atlassian.com',
    slackChannel: 'help-community',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46',
    ],
  },
  {
    experience: AdvancedCobranding.CHAMPION_APPLY,
    Component: lazy(() => import('../../advanced-cobranding/community/champion-apply/login-page')),
    owner: 'vmanjunath@atlassian.com',
    slackChannel: 'help-community',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46',
    ],
  },
  {
    experience: AdvancedCobranding.CHAMPION_CONSENT,
    Component: lazy(
      () => import('../../advanced-cobranding/community/champion-consent/login-page')
    ),
    owner: 'vmanjunath@atlassian.com',
    slackChannel: 'help-community',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46',
    ],
  },
  {
    experience: AdvancedCobranding.ENTRY_AUTH,
    Component: lazy(() => import('../../advanced-cobranding/community/entry-auth/login-page')),
    owner: 'vmanjunath@atlassian.com',
    slackChannel: 'help-community',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46',
    ],
  },
  {
    experience: AdvancedCobranding.LOOM,
    Component: lazy(() => import('../../advanced-cobranding/loom/LoginPage')),
    owner: 'rbaldwin@atlassian.com',
    slackChannel: 'loom-team-identity',
    monitoringUrls: [
      'stg: https://pollinator.prod.atl-paas.net/checks/6309c2e3-d103-4f67-aeee-ba4c625602ea',
    ],
  },
  {
    experience: AdvancedCobranding.ISOLATED_CLOUD,
    Component: lazy(() => import('../../advanced-cobranding/isolated-cloud/loginPage')),
    owner: 'fharrold@atlassian.com',
    slackChannel: 'id-kirby',
    monitoringUrls: ['TODO: https://hello.jira.atlassian.cloud/browse/IDOASIS-101'],
  },
  {
    experience: AdvancedCobranding.TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE,
    Component: lazy(() => import('../../advanced-cobranding/growth/twcg-786/components/LoginPage')),
    owner: 'tdermisek@atlassian.com',
    slackChannel: 'team-puma',
    monitoringUrls: [
      // https://hello.jira.atlassian.cloud/browse/PUMA-1559
      'TODO: PUMA-1559 Add pollinator check for TWCG-786 prioritise SSO login',
    ],
  },
];
